function MovieDataPush () {
  const element = document.querySelectorAll(".owd-youtube-popup-js")
  element.forEach(e => {
    e.addEventListener("click", ()=> {
      const eData = e.getAttribute("data-ga-movie-start")
      dataLayer.push({
        event: 'video_start',
        eventLabel: eData
      });
    })
  });
}

export {MovieDataPush}
